import React, { useCallback, useState } from 'react';

import ProtocolForm from '../../../../views/Protocol/form';
import { DynamicLayoutModal } from 'components/Modal/DynamicLayoutModal';

const ProtocolModal = ({
  isModalOpen,
  onModalToggle,
  defaultFormData,
  createdFrom = '',
  fatherProtocol = undefined,
  onProtocolUpdate,
  ...props
}) => {
  const [createSubProtocol, setCreateSubProtocol] = useState(null);
  const closeModal = useCallback(() => {
    onModalToggle(false);
    setCreateSubProtocol(null);
    localStorage.setItem('isFromUpdate', false);
  }, [onModalToggle]);

  return (
    <DynamicLayoutModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      defaultFormData={defaultFormData}
      createdFrom={createdFrom}
      fatherProtocol={fatherProtocol}
      title={
        createSubProtocol === false
          ? 'Associar protocolo a um existente'
          : 'Protocolo de atendimento'
      }
      showCloseButton={false}
      centered={true}
      backdrop={true}
      closeModal={closeModal}
      hasDynamicLayout={true}
      minWidth={300}
      maxWidth={800}
      isToClickOutsideClose={false}
      createSubProtocol={createSubProtocol}
      onProtocolUpdate={onProtocolUpdate}
      {...props}
    >
      <ProtocolForm
        modalActions={{ closeModal, defaultFormData }}
        selectedRecordTypeId={defaultFormData?.recordTypeId}
        createdFrom={createdFrom}
        isFromUpdate={localStorage.getItem('isFromUpdate')}
        fatherProtocol={fatherProtocol}
        createSubProtocol={createSubProtocol}
        setCreateSubProtocol={setCreateSubProtocol}
        onProtocolUpdate={onProtocolUpdate}
      />
    </DynamicLayoutModal>
  );
};

export default ProtocolModal;
